import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export const Hero = () => {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  // Parallax effects
  const yBg = useTransform(scrollYProgress, [0, 1], ['0%', '20%']);
  const scaleBg = useTransform(scrollYProgress, [0, 1], [1, 0.95]);
  const yText = useTransform(scrollYProgress, [0, 1], ['0%', '-30%']);
  const opacityText = useTransform(scrollYProgress, [0, 0.8], [1, 0]);
  return <section ref={ref} className="relative min-h-screen flex items-center overflow-hidden bg-brand-dark" data-id="element-111">
      {/* Full-width Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-112">
        <motion.div style={{
        y: yBg,
        scale: scaleBg
      }} initial={{
        scale: 1.05,
        opacity: 0,
        filter: 'blur(4px)'
      }} animate={{
        scale: 1,
        opacity: 1,
        filter: 'blur(0px)'
      }} transition={{
        duration: 2,
        ease: [0.16, 1, 0.3, 1]
      }} className="w-full h-full origin-top" data-id="element-113">
          <img src="https://cdn.magicpatterns.com/uploads/c7DtgUV4minxineBKqyaMP/IMG_2681-PROOF-THOMAS-MASOTTI.jpg" alt="Séance de détatouage laser sur un bras tatoué chez Dispel Your Tattoo à Martigny, Valais" className="w-full h-full object-cover object-[70%_center] md:object-center grayscale-[20%]" fetchPriority="high" data-id="element-114" />
        </motion.div>

        {/* Gradients for text readability and cinematic feel */}
        <div className="absolute inset-0 bg-gradient-to-r from-brand-darker via-brand-darker/80 to-transparent w-full md:w-[70%]" data-id="element-115"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-brand-darker via-transparent to-transparent h-full" data-id="element-116"></div>
      </div>

      {/* Content */}
      <motion.div style={{
      y: yText,
      opacity: opacityText
    }} className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 w-full pt-32 pb-20" data-id="element-117">
        <div className="max-w-3xl" data-id="element-118">
          <motion.div initial={{
          opacity: 0,
          y: 40,
          filter: 'blur(8px)'
        }} animate={{
          opacity: 1,
          y: 0,
          filter: 'blur(0px)'
        }} transition={{
          duration: 1.2,
          delay: 0.4,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-119">
            <h1 className="text-5xl md:text-7xl lg:text-[6.5rem] leading-[1.02] text-brand-light mb-10 font-black tracking-tighter text-balance" data-id="element-120">
              Détatouage Professionnel en Valais
            </h1>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 30,
          filter: 'blur(8px)'
        }} animate={{
          opacity: 1,
          y: 0,
          filter: 'blur(0px)'
        }} transition={{
          duration: 1.2,
          delay: 0.6,
          ease: [0.16, 1, 0.3, 1]
        }} className="text-lg md:text-xl lg:text-2xl text-brand-gray/90 max-w-2xl mb-14 font-light leading-relaxed" data-id="element-121">
            Bienvenue chez Dispel Your Tattoo, un espace entièrement dédié au
            détatouage, situé au sein du salon Pleine Lune Tattoo à Martigny, en
            Valais. Mon travail est exclusivement concentré sur l'effacement de
            tatouages, ce qui me permet de proposer une expertise spécialisée,
            précise et constamment actualisée. Depuis maintenant quatre ans,
            j'accompagne mes clients vers un résultat sûr, maîtrisé et adapté à
            chaque type de peau.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col sm:flex-row items-start sm:items-center space-y-6 sm:space-y-0 sm:space-x-10" data-id="element-122">
            <motion.a href="#contact" whileHover={{
            scale: 1.02,
            boxShadow: '0 0 20px rgba(245,245,240,0.1)'
          }} transition={{
            duration: 0.3,
            ease: 'easeOut'
          }} className="px-10 py-5 bg-brand-light text-brand-dark rounded-full font-bold uppercase tracking-wider hover:bg-white transition-colors duration-300 text-sm md:text-base" data-id="element-123">
              Réserver une consultation
            </motion.a>
            <a href="#technology" className="group flex items-center space-x-3 text-brand-gray hover:text-brand-light transition-colors duration-300" data-id="element-124">
              <span className="text-sm font-medium uppercase tracking-widest" data-id="element-125">
                Découvrir le traitement
              </span>
              <ArrowRight size={18} className="group-hover:translate-x-2 transition-transform duration-300" data-id="element-126" />
            </a>
          </motion.div>
        </div>
      </motion.div>
    </section>;
};